import SVGA from 'svgaplayerweb';
const i18nConfig = require('@config/i18n').default;

export function loadSVGA(selector, src) {
  const player = new SVGA.Player(selector);
  const parser = new SVGA.Parser(selector); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
  parser.load(src, (videoItem) => {
    player.setVideoItem(videoItem);
    player.startAnimation();
  });
}

export const getParamFromUrl = (param) => {
  /** 获取浏览器上链接的query信息 */
  const urlInfoMap = window.document.location.search
    .substring(1)
    .split('&')
    .reduce((acc, cur) => {
      const [key, value] = cur.split('=');
      acc[key] = value;
      return acc;
    }, {});

  return urlInfoMap[param] || '';
};

export const checkIsMobile = (headers = {}) => {
  const REG = /.*Mobile.*/;
  let isMobile = false;
  if (process.server) {
    const userAgent = headers['user-agent'] || '';
    isMobile = !!userAgent.match(REG);
  } else {
    const { userAgent } = navigator;
    isMobile = !!userAgent.match(REG);
  }

  return isMobile;
};

/**
 * 是否是安卓
 */
export const isAndroid = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  return /(android|Android)/i.test(userAgent);
};

/**
 * 是否ios端
 */
export const isIOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  return /ipad|iphone|ipod/i.test(userAgent);
};

/**
 *设置cookie
 * @param {cookie name} name
 * @param {cookie vlaue} value
 * @param {Object} config.expired:过期时间； config.domain:cookie域；config.path: cookie路径
 */
export const setCookie = (name, value, config = {}) => {
  const cookiePath = config.path ? config.path : '/';
  const _domain = config.domain ? `;domain=${config.domain}` : '';

  if (!config.expired) {
    // 默认 0 点过期
    const nowTime = new Date();
    nowTime.setUTCHours(24);
    nowTime.setUTCMinutes(0);
    nowTime.setUTCSeconds(0);
    config.expired = nowTime.toUTCString();
  }
  document.cookie = `${name}=${value};expires=${config.expired}${_domain};path=${cookiePath}`;
};

/**
 *
 *获取cookie
 * @param {String} cname cookie键值
 * @returns
 */
export const getCookie = (cname) => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

/**
 *
 * 根据语言码获取国家码
 * @param {String} locale 当前语言码
 * @param {String} isGame game播优先选择后端接口可请求的国家，show播优先前端可选国家码
 * @returns
 */
export const getCountryCode = (locale, isGame) => {
  const findLang = i18nConfig.locales.filter((i) => {
    return i.code === locale;
  });
  let tabType = 'ALL';
  if (findLang && findLang[0]) {
    if (isGame) {
      tabType = findLang[0].country; // country 是后端接口可请求的国家，较多
    } else {
      tabType = findLang[0].searchCountry || findLang[0].country; // searchCountry 是对应可选国家里的，较少
    }
  }
  return tabType;
};
